var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.5,
    height: 23.5,
    viewBox: "0 0 23.5 23.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18647",
    "data-name": "Path 18647",
    d: "M12.215,20.762H3.069a.215.215,0,0,1-.151-.063.212.212,0,0,1-.063-.151V19a3.034,3.034,0,0,1,1.612-2.336,14.28,14.28,0,0,1,7.748-1.943.8.8,0,0,0,0-1.6,15.92,15.92,0,0,0-8.653,2.221A4.58,4.58,0,0,0,1.25,19v1.552a1.819,1.819,0,0,0,1.819,1.819h9.147a.8.8,0,1,0,0-1.6Z",
    transform: "translate(0 0.828)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18648",
    "data-name": "Path 18648",
    d: "M11.884,1.25a5.884,5.884,0,1,0,5.884,5.884A5.886,5.886,0,0,0,11.884,1.25Zm0,1.6A4.279,4.279,0,1,1,7.6,7.134,4.281,4.281,0,0,1,11.884,2.855Z",
    transform: "translate(0.331)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18649",
    "data-name": "Path 18649",
    d: "M17.749,13.938a3.811,3.811,0,1,0,3.812,3.811A3.812,3.812,0,0,0,17.749,13.938Zm0,1.6a2.206,2.206,0,1,1-2.207,2.206A2.208,2.208,0,0,1,17.749,15.543Z",
    transform: "translate(0.885 0.885)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18650",
    "data-name": "Path 18650",
    d: "M18.355,14.857v-1.8a.8.8,0,1,0-1.6,0v1.806a.8.8,0,1,0,1.6,0Z",
    transform: "translate(1.081 0.767)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18651",
    "data-name": "Path 18651",
    d: "M20.108,16.215l1.276-1.277A.8.8,0,1,0,20.251,13.8L18.973,15.08a.8.8,0,1,0,1.135,1.135Z",
    transform: "translate(1.22 0.859)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18652",
    "data-name": "Path 18652",
    d: "M20.364,18.355H22.17a.8.8,0,0,0,0-1.6H20.364a.8.8,0,0,0,0,1.6Z",
    transform: "translate(1.278 1.081)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18653",
    "data-name": "Path 18653",
    d: "M18.973,20.108l1.277,1.276a.8.8,0,1,0,1.134-1.134l-1.276-1.277a.8.8,0,1,0-1.135,1.135Z",
    transform: "translate(1.22 1.22)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18654",
    "data-name": "Path 18654",
    d: "M16.75,20.364V22.17a.8.8,0,0,0,1.6,0V20.364a.8.8,0,0,0-1.6,0Z",
    transform: "translate(1.081 1.278)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18655",
    "data-name": "Path 18655",
    d: "M15.08,18.973,13.8,20.251a.8.8,0,1,0,1.134,1.134l1.277-1.276a.8.8,0,1,0-1.135-1.135Z",
    transform: "translate(0.859 1.22)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18656",
    "data-name": "Path 18656",
    d: "M14.857,16.75h-1.8a.8.8,0,1,0,0,1.6h1.8a.8.8,0,0,0,0-1.6Z",
    transform: "translate(0.767 1.081)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18657",
    "data-name": "Path 18657",
    d: "M16.215,15.08,14.937,13.8A.8.8,0,0,0,13.8,14.937l1.276,1.277a.8.8,0,0,0,1.135-1.135Z",
    transform: "translate(0.859 0.859)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmins);
export default __webpack_public_path__ + "static/media/admins.d02368a1378d0b9e2686abe394e462b6.svg";
export { ForwardRef as ReactComponent };